import CardMedia from './CardMedia'
import { CardTierBadge } from './TierBadge'
import {
  CardElements,
  CardLink,
  TypeChip,
  hasMedia,
  mediaLimit,
  useCardTranslation,
  type TemplateProps,
} from './card-parts'

/** Contained card: photo on top, then name, location, price and the meta row. */
export default function TemplateClassic({ property, options }: TemplateProps) {
  const { _t } = useCardTranslation(options)
  const media = hasMedia(property, options)

  return (
    <div className="hr-pc-card hr-pc-card--classic">
      <CardLink property={property} options={options} />
      <CardMedia property={property} limit={mediaLimit(options)} aspectRatio={options.imageAspectRatio} t={_t}>
        <TypeChip property={property} options={options} />
        <CardTierBadge property={property} config={options.tierRating} at="media" />
      </CardMedia>

      <div className="hr-pc-body">
        {!media ? <TypeChip property={property} options={options} /> : null}
        <CardElements property={property} options={options} template="classic" />
      </div>
    </div>
  )
}
